import React from 'react';

import { AddOutlined, CloseOutlined } from '@mui/icons-material';
import { ButtonBase, Stack } from '@mui/material';

const BUTTON_SX = {
  border: '1px solid',
  borderColor: 'cadet.400',
  width: 32,
  height: 32,
  borderRadius: '4px',
  bgcolor: '#FFFFFF',
};

type Props = {
  setAnchorEl: (v: HTMLElement) => void;
  value: string;
  onChange: (value: string | null) => void;
  disableReset: boolean;
};
export default function TriggerButton({ setAnchorEl, value, disableReset, onChange }: Props) {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const renderResetButton = () => {
    if (disableReset) {
      return null;
    }
    if (typeof value !== 'string' || value.trim().length === 0) {
      return null;
    }
    return (
      <ButtonBase onClick={() => onChange(null)}>
        <CloseOutlined fontSize="small" sx={{ color: 'grey.600' }} />
      </ButtonBase>
    );
  };

  const renderButton = () => {
    if (value) {
      return <ButtonBase onClick={handleClick} sx={{ ...BUTTON_SX, bgcolor: value }} />;
    }
    return (
      <ButtonBase onClick={handleClick} sx={{ ...BUTTON_SX }}>
        <AddOutlined fontSize="small" />
      </ButtonBase>
    );
  };

  return (
    <Stack direction="row" spacing={1}>
      {renderButton()}
      {renderResetButton()}
    </Stack>
  );
}
